/**
 * Format a 10-digit US phone string as (XXX) XXX-XXXX.
 * Returns the original value if it isn't exactly 10 digits.
 */
export function formatPhone(value: string | null | undefined): string | null {
  if (!value) {
    return null
  }
  const digits = value.replace(/\D/g, '')
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }
  return value
}
